import { render, staticRenderFns } from "./CommissionDetailsModal.vue?vue&type=template&id=6d0dce75&scoped=true"
import script from "./CommissionDetailsModal.vue?vue&type=script&lang=js"
export * from "./CommissionDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./CommissionDetailsModal.vue?vue&type=style&index=0&id=6d0dce75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0dce75",
  null
  
)

export default component.exports